import { defineStyleConfig } from "@chakra-ui/react"

export const textareaTheme = defineStyleConfig({
  baseStyle: props => ({
    "::placeholder": {
      color: props.colorMode === "light" ? "gray.500" : "whiteAlpha.700",
    },
  }),
})
